import { CANVASES } from "./canvases";
/** Above this the table would look silly on a large monitor and cards go soft. */
/** Discord desktop hands the Activity a wide, short area (about 1550x600 with the member strip); 1.25 left it letterboxed. */
export const MAX_SCALE = 1.6;
/** The wide canvas needs both dimensions: a phone in landscape passes 768 wide but not 640 tall. */
export const WIDE_MIN_WIDTH = 768;
export const WIDE_MIN_HEIGHT = 640;
export function chooseState(width, height) {
    if (width >= WIDE_MIN_WIDTH && height >= WIDE_MIN_HEIGHT)
        return "wide";
    return width > height ? "phoneLandscape" : "portrait";
}
/** Picks the state and computes scale and offsets. The only place that knows viewport pixels. */
export function measure(viewport) {
    const insets = viewport.insets ?? {};
    const width = Math.max(1, viewport.width - (insets.left ?? 0) - (insets.right ?? 0));
    const height = Math.max(1, viewport.height - (insets.top ?? 0) - (insets.bottom ?? 0));
    const state = chooseState(width, height);
    const canvas = CANVASES[state];
    // Scale from the short axis; the long axis flexes and the surplus goes to the cloth.
    const scale = Math.min(width / canvas.w, height / canvas.h, MAX_SCALE);
    const offsetX = (insets.left ?? 0) + (width - canvas.w * scale) / 2;
    const offsetY = (insets.top ?? 0) + (height - canvas.h * scale) / 2;
    return { state, canvas, scale, offsetX, offsetY, width, height };
}
/** Minimum touch target in CSS px (WCAG 2.5.5 target size). */
export const TOUCH_TARGET_PX = 44;
/** Floor when the whole canvas is zoomed out (WCAG 2.5.8 minimum). */
export const TOUCH_FLOOR_PX = 24;
/**
 * Drawn size stays the designer's; the pressed area grows to the touch target.
 * Returns the padding to add around the drawn rect, in canvas units.
 */
export function touchPadding(drawnPx, scale) {
    const target = scale < 1 ? TOUCH_FLOOR_PX : TOUCH_TARGET_PX;
    const shortfall = target - drawnPx * scale;
    return shortfall <= 0 ? 0 : shortfall / scale / 2;
}
/**
 * Horizontal step between overlapping cards so a whole hand fits the slot;
 * the first card is fully visible, the rest show at least their left edge.
 */
export function fanStep(slotW, cardW, count, gap = 4) {
    if (count <= 1)
        return 0;
    return Math.max(0, Math.min(cardW + gap, (slotW - cardW) / (count - 1)));
}
/** Rotation of the i-th card of a fanned hand, symmetric around the middle, in degrees. */
export function fanAngle(index, count, arc) {
    if (count <= 1)
        return 0;
    return -arc + (2 * arc * index) / (count - 1);
}
//# sourceMappingURL=measure.js.map